import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import {
  faChalkboardTeacher,
  faKeyboard,
  faCheck,
  faFont,
  faBook,
  faLineColumns,
  faScalpelLineDashed,
} from '@fortawesome/pro-light-svg-icons';

import {
  APP_TITLES,
  APP_READING,
  APP_WORD_WORK,
  APP_WORD_SORT,
  APP_WORD_DIVISION,
  APP_WRITING,
  APP_ASSESSMENT,
  LESSON,
} from '../../constants';

const exerciseIcon = {
  [APP_ASSESSMENT]: faCheck,
  [APP_READING]: faBook,
  [APP_WORD_DIVISION]: faScalpelLineDashed,
  [APP_WORD_SORT]: faLineColumns,
  [APP_WORD_WORK]: faFont,
  [APP_WRITING]: faKeyboard,
};

const EXERCISE_TYPES = [APP_ASSESSMENT, APP_READING, APP_WORD_DIVISION, APP_WORD_SORT, APP_WORD_WORK, APP_WRITING];

export default function AssignmentTypeMenu({anchorEl, isOpen, setIsOpen, handleClickType}) {
  return (
    <Menu anchorEl={anchorEl} open={isOpen} onClose={() => setIsOpen(false)} keepMounted>
      <MenuItem onClick={() => handleClickType(LESSON)}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faChalkboardTeacher} className="clr-primary" />
        </ListItemIcon>
        <ListItemText primary="Lesson" />
      </MenuItem>

      <Divider />

      {EXERCISE_TYPES.map((exerciseType) => {
        return (
          <MenuItem key={APP_TITLES[exerciseType]} onClick={() => handleClickType(exerciseType)}>
            <ListItemIcon>
              <FontAwesomeIcon icon={exerciseIcon[exerciseType]} className="clr-primary" />
            </ListItemIcon>
            <ListItemText primary={APP_TITLES[exerciseType]} />
          </MenuItem>
        );
      })}
    </Menu>
  );
}
